// Slide Navigator
import SlideTray from './SlideTray';
import WebViewer from 'viewer/index';
import icon from './workflow-icon.png';

WebViewer.addWorkflow({
  component: SlideTray,
  icon,
  title: 'slides.title'
});



// WEBPACK FOOTER //
// ./src/slide-tray-workflow/index.js